import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface ICreditCheckApiClient {
    checkCustomerFicoCreditScore: (request: Models.Customer.CustomerCreditCheckModel.CustomerCreditCheckModel) => ng.IPromise<
        Models.Customer.CustomerCreditCheckResponseModel.CustomerCreditCheckResponseModel>;

    getCustomerConfirmationInformation: (igsCustomerNumber: string) => ng.IPromise<any>;

    sendCustomerCreditCheckInviteEmail: (igsCustomerNumber: string) => ng.IPromise<Models.CreditCheckEmailResponse>;

    approveCustomerCreditCheckNameEqualityRecord: (igsCustomerNumber: string) => ng.IPromise<Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord>;

    getCustomerCreditCheckNameEqualityRecord: (igsCustomerNumber: string) => ng.IPromise<Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord>;
}

export class CreditCheckApiClient implements ICreditCheckApiClient {
    public prefix: string;

    public static $inject = [
        "igs.apiClientService"
    ];

    constructor(
        private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "CreditCheck";
    }

    public checkCustomerFicoCreditScore(request: Models.Customer.CustomerCreditCheckModel.CustomerCreditCheckModel): angular.IPromise<Models.Customer.CustomerCreditCheckResponseModel.CustomerCreditCheckResponseModel> {
        var url = `${this.prefix}/CheckCustomerFicoCreditScore`;
        return this.igsApiClientService.post(url, request);
    }

    public getCustomerConfirmationInformation(igsCustomerNumber: string): ng.IPromise<any> {
        var url = `${this.prefix}/GetCustomerConfirmation/${igsCustomerNumber}`;
        return this.igsApiClientService.get(url);
    }

    public getCustomerCreditCheckNameEqualityRecord(igsCustomerNumber: string): ng.IPromise<Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord> {
        var url = `${this.prefix}/Customer/${igsCustomerNumber}/GetCreditCheckNameEqualityRecord`;
        return this.igsApiClientService.get(url);
    }

    public approveCustomerCreditCheckNameEqualityRecord(igsCustomerNumber: string): ng.IPromise<Models.CustomerCreditCheckName.ICustomerCreditCheckNameEqualityRecord> {
        var url = `${this.prefix}/Customer/${igsCustomerNumber}/ApproveCreditCheckNameEqualityRecord`;
        return this.igsApiClientService.post(url);
    }

    public sendCustomerCreditCheckInviteEmail(igsCustomerNumber: string): ng.IPromise<Models.CreditCheckEmailResponse> {
        var url = `${this.prefix}/CustomerInvite/Send/${igsCustomerNumber}`;
        return this.igsApiClientService.post(url);
    }
}
